import * as React from 'react';
import { FaInfo } from 'react-icons/fa';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { Textbox, ValidationProps } from 'ui';
import styles from './change-id.scss';

interface ChangePersonIdComponentProps {
  personId: string;
  editingSelf: boolean;
  onClose: () => void;
  setPersonId: (personId: string) => void;
  validation: ValidationProps;
  clearValidation: (fieldName: string) => void;
  fetching: boolean;
  textTitle: string;
  textOldPersonId: string;
  textNewPersonId: string;
  textDoneButton: string;
  textCancel: string;
  textDisclaimer: string;
}

interface ChangePersonIdComponentState {
  newPersonId: string;
}

class ChangePersonIdComponent extends React.Component<ChangePersonIdComponentProps, ChangePersonIdComponentState> {
  public state:Readonly<ChangePersonIdComponentState> = {
    newPersonId: ''
  };

  private handleNewPersonIdChange = (value: string) => {
    this.setState({
      newPersonId: value
    });
  };

  private clearValidation = () => {
    if (!!this.props.validation) {
      this.props.clearValidation('personId');
    }
  };

  private handleDone = () => {
    this.clearValidation();
    this.props.setPersonId(this.state.newPersonId);
  };

  private handleClose = () => {
    this.clearValidation();
    this.props.onClose();
  };

  public render() {

    const { personId, editingSelf, validation, fetching,
      textTitle, textOldPersonId, textNewPersonId, textDoneButton, textCancel, textDisclaimer } = this.props;
    return (<ModalWrapper
      headerTitle={textTitle}
      btnTitle={textDoneButton}
      btnCancelTitle={textCancel}
      onClose={this.handleClose}
      onDone={this.handleDone}
      closeOnDone={false}
      largeSize={false}
      isDisabled={fetching}>
      {editingSelf && <div className={styles.disclaimerPanel}>
        <FaInfo /> {textDisclaimer}
      </div>}
      <Textbox
        readOnly={true}
        componentId={'oldPersonId'}
        onChange={undefined}
        className={''}
        label={{ text: textOldPersonId, required: false }}
        value={personId} />
      <Textbox
        componentId={'newPersonId'}
        onChange={this.handleNewPersonIdChange}
        className={''}
        label={{ text: textNewPersonId, required: true }}
        value={this.state.newPersonId}
        validation={validation}
        readOnly={fetching} />
    </ModalWrapper>);
  }
}

export const ChangePersonId = ChangePersonIdComponent;
